import { DailyVideo } from "@daily-co/daily-react";
import { Box } from "@mui/material";

interface AvatarVideoProps {
  id: string;
}

const AvatarVideo: React.FC<AvatarVideoProps> = (props) => {
  const { id } = props;
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
      }}
    >
      <DailyVideo
        automirror
        sessionId={id}
        type="video"
        fit="cover"
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </Box>
  )
}

export default AvatarVideo;
